// src/Redux/User/UserSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: null,
  notificationCount: 0, 
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser(state, action) {
      state.user = action.payload;
    },
    updateUser(state, action) { // Optional: Added from other project for future use (e.g., partial user updates)
      if (state.user) {
        state.user = { ...state.user, ...action.payload };
      }
    },
    clearUser(state) {
      state.user = null;
      state.notificationCount = 0; // Reset notification count on logout
    },
    setNotificationCount(state, action) { // Added to match other project
      state.notificationCount = action.payload;
    },
  },
});

export const { setUser, updateUser, clearUser, setNotificationCount } = userSlice.actions;

export default userSlice.reducer;